

    <svg:g [attr.transform]="transform" class="graph-vertex">

      <svg:g (mousedown)="onMouseDown($event)" (dblclick)="onDblClick($event)">
        <svg:path [attr.d]="vis.shape.representation.path.join(' ')" stroke-linecap="round"
                  [attr.stroke]="backgroundOverride(vis.stroke.fill)" [attr.stroke-width]="vis.stroke.width"
                  [attr.fill]="backgroundOverride(vis.shape.fill)"/>

        <svg:text [attr.x]="vis.text.primary.at.x" text-anchor="middle" [attr.y]="vis.text.primary.at.y"
                  [attr.font-size]="vis.text.primary.size"
                  [attr.fill]="foregroundOverride(vis.text.primary.fill)">{{ specifications.abbr }}
        </svg:text>

        <svg:text [attr.x]="vis.text.secondary.at.x" [attr.y]="vis.text.secondary.at.y" text-anchor="middle"
                  [attr.font-size]="vis.text.secondary.size"
                  font-weight="bold"
                  [attr.fill]="foregroundOverride(vis.text.secondary.fill)">
          {{ name }}
        </svg:text>
      </svg:g>

      <svg:g class="points">
        <svg:g *ngFor="let point of vertex.inlets; let i = index" wf-graph-vertex-inlet-point [vertex]="vertex"
               [point]="point" [editable]="editable" [specification]="getInletSpecification(i)"/>

        <svg:g *ngFor="let point of vertex.outlets; let i = index" wf-graph-vertex-outlet-point [vertex]="vertex"
               [point]="point" [editable]="editable" [specification]="getOutletSpecification(i)"/>
      </svg:g>
    </svg:g>

  


// WEBPACK FOOTER //
// ./src/library/graph/vertex/workflow-graph-vertex.component.ts.WorkflowGraphVertexComponent.html